import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MfeCoreModule } from '@mynexus/mfe-core';
import { SecurityModule } from '@mynexus/mynexus-ui-lib';
import { QueueActionButtonsComponent } from '@shared/component/queue-action-buttons/queue-action-buttons.component';
import { DirectiveModule } from 'src/app/shared';
import { ToggleSwitch, ToggleSwitchModule } from 'primeng/toggleswitch';

@Component({
  selector: 'nexus-sdoh-queue',
  templateUrl: './sdoh-queue.component.html',
  styleUrls: ['./sdoh-queue.component.scss'],
  imports: [
    FormsModule,
    DirectiveModule,
    MfeCoreModule,
    QueueActionButtonsComponent,
    DirectiveModule,
    SecurityModule,
    ToggleSwitch,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SdohQueueComponent {
  public showHighlighted = false;

  constructor(private readonly router: Router) {}

  public memberClicked(e: CustomEvent): void {
    this.router.navigate([
      e.detail.tenantId,
      'member',
      e.detail.subscriberNumber,
    ]);
  }

  public referralNumberClicked(e: CustomEvent): void {
    const { tenantId, referralId, memberId } = e.detail;

    const navigationState = {
      targetWidget: 'SDoH',
      tenantId,
      referralId,
      memberId,
    };

    this.router.navigate(
      [e.detail.tenantId, 'member', e.detail.subscriberNumber],
      {
        state: navigationState,
      }
    );
  }

  public showHighlightedChanged(e: CustomEvent): void {
    this.showHighlighted = e.detail === true;
  }
}
